import classNames from "classnames";
import React from "react";

interface InputFieldProps {
  type?: string;
  value: string;
  onChange?: (e: any) => void;
  placeholder?: string;
  className?: string;
  styles?: React.CSSProperties;
  isValidateField?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  type = "text",
  value,
  styles,
  onChange,
  placeholder,
  className,
  isValidateField = false,
  readonly = false,
  disabled = false,
  error = false,
  errorMessage = "",
}) => {
  return (
    <div className={classNames(className, "w-full relative")}>
      <input
        readOnly={readonly}
        disabled={disabled}
        style={{ ...styles }}
        className={classNames(
          className,
          disabled ? "text-[#414141]" : "text-white",
          "w-full bg-[#141419] text-sm  px-8 py-2.5 rounded-lg border border-[#666666] outline-none focus:border-primary-1 placeholder:text-[#414141]"
        )}
        value={value}
        type={type}
        onChange={onChange}
        placeholder={placeholder}
      />
      {isValidateField && (
        <span className="text-primary-1 text-sm block absolute right-8 top-1/2 -translate-y-1/2 pl-2 border-l border-[#414141]">
          @Blazpay
        </span>
      )}
      {error && (
        <span className="text-xs block mt-1 ml-2 text-[#ff3503]">
          {errorMessage}
        </span>
      )}
    </div>
  );
};

export default InputField;
